import styles from './Page.module.css'; 

import Choice from "./Choice";
import Story from "./Story";

import _story from '../story.json'
import scrollTop from './scroll_top.png'
import scrollBottom from './scroll_bottom.png'
import { useState } from 'react';

interface PageProps {
  currentPage: string;   // TODO: Import this
  setCurrentPage: (currentPage: string) => void;
}

interface StoryObject {
  [index: string]: {
    content?: string
    choices:
      {
        text: string
        target: string
      }[]
  };
}

const story = _story as StoryObject;

function Page(props: PageProps) {
  const [storyLoading, setStoryLoading] = useState(true);
  const current = story[props.currentPage as keyof typeof story]

  return (
    <div className={styles.Page}>
      <div className={styles.Scroll}>
        <img src={scrollTop} className={styles.ScrollTop} alt='' />
        <div className={styles.PageContent}>
          <Story content={current.content || props.currentPage} onLoaded={() => setStoryLoading(false)}  />
          <div className={styles.PageChoices}>
            {storyLoading ? null : current.choices.map((c, idx) => <Choice key={`choice_${idx}`} text={c.text} onClick={() => { setStoryLoading(true); props.setCurrentPage(c.target); }}/>)}
            {storyLoading ? null : current.choices.length === 0 ? <Choice text="Start again" onClick={() => { setStoryLoading(true); props.setCurrentPage("start"); }} /> : null }
          </div>
        </div>
        <img src={scrollBottom} className={styles.ScrollBottom} alt='' />
      </div>
    </div>
  );
}

export default Page;
